import React from "react";
import { Card, CardContent } from "../components/ui/card";
import { CheckCircle2, Shield, Leaf, Users, Truck, Globe } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const OurResponsibilities = () => {
  const responsibilities = [
    {
      icon: <Users className="h-10 w-10 text-emerald-700" />,
      title: "Supporting Farmers",
      description:
        "We work directly with farmers to provide fair pricing, training, and long-term income stability.",
    },
    {
      icon: <Leaf className="h-10 w-10 text-emerald-700" />,
      title: "Sustainable Farming",
      description:
        "We promote eco-friendly farming methods to protect soil health and reduce environmental impact.",
    },
    {
      icon: <Shield className="h-10 w-10 text-amber-600" />,
      title: "Quality Assurance",
      description:
        "Every product is carefully inspected to ensure it meets international export standards.",
    },
    {
      icon: <Truck className="h-10 w-10 text-amber-600" />,
      title: "Safe Logistics",
      description:
        "We ensure safe packaging, cold chain handling, and timely delivery across global markets.",
    },
    {
      icon: <Globe className="h-10 w-10 text-emerald-700" />,
      title: "Global Standards",
      description:
        "We follow strict international food safety and export compliance regulations.",
    },
    {
      icon: <CheckCircle2 className="h-10 w-10 text-amber-600" />,
      title: "Ethical Trade",
      description:
        "We believe in transparency, honesty, and fair trade practices in every transaction.",
    },
  ];

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-white">
        {/* HERO */}
        <section className="py-24 bg-emerald-900 text-white text-center">
          <div className="max-w-4xl mx-auto px-4">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Our Responsibilities
            </h1>
            <p className="text-lg md:text-xl text-emerald-100">
              We are committed to farmers, quality, sustainability, and global
              excellence in every step of our supply chain.
            </p>
          </div>
        </section>

        {/* CONTENT */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {responsibilities.map((item, index) => (
                <Card
                  key={index}
                  className="hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-t-4 border-t-emerald-600"
                >
                  <CardContent className="p-8">
                    <div className="mb-5">{item.icon}</div>

                    <h3 className="text-2xl font-bold text-gray-900 mb-3">
                      {item.title}
                    </h3>

                    <p className="text-gray-600 leading-relaxed">
                      {item.description}
                    </p>
                  </CardContent>
                </Card>
              ))}
            </div>

            {/* BOTTOM SECTION */}
            <div className="mt-20 bg-white rounded-2xl shadow-lg p-10 text-center">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Building a Better Agricultural Future
              </h2>

              <p className="text-gray-600 max-w-3xl mx-auto">
                Our responsibility goes beyond trade — we aim to empower
                farmers, ensure safe food supply, and promote sustainable
                agriculture worldwide.
              </p>

              <div className="mt-6 flex justify-center">
                <div className="flex items-center space-x-2 text-emerald-700 font-medium">
                  <CheckCircle2 />
                  <span>Committed to Ethical Agriculture</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default OurResponsibilities;
